import Label from "components/Label/Label";
import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import Textarea from "shared/Textarea/Textarea";
import CommonLayout from "./CommonLayout";
import { Helmet } from "react-helmet-async";
import  { useEffect,useState } from "react";
import Cookies from "js-cookie";

export interface AccountPageProps {
  className?: string;
}

const AccountPage: FC<AccountPageProps> = ({ className = "" }) => {
   const userDataString = Cookies.get("userDataaInfo");
    const SignupData = Cookies.get('SignupData');
    const Info =Cookies.get('CustomerInfo');
   const [userData, setUserData] = useState<any>(null);
   const [customerInfo,setCustomerInfo]=useState<any>(null)
    useEffect(() => {
    const fetchDataFromApi = async () => {
      try {
        // Try to get user data from cookies in priority order
        // 1. CustomerInfo cookie has the customer DTO directly (works for both Kanopy and Auth.net)
        if (Info) {
          const customerData = JSON.parse(Info);
          setUserData(customerData);
          return;
        }
        // 2. Fallback: Auth.net billTo from the profile structure
        if (SignupData && userDataString) {
          const responsetwo = JSON.parse(userDataString);
          const billTo = responsetwo["AuthNet Profile Info "]?.profile?.paymentProfiles?.[0]?.billTo;
          if (billTo) {
            setUserData(billTo);
            return;
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (!userData) {
      fetchDataFromApi();
    }
  }, [userDataString, SignupData, Info]);
  return (
    <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
      <Helmet>
        <title>Basil POS Online Ordering</title>
      </Helmet>
      <CommonLayout>
        <div className="space-y-1 sm:space-y-7">
          {/* HEADING */}
          <h2 className="text-xl sm:text-xl font-semibold">
            Account information
          </h2>
          <div className="flex flex-col md:flex-row">
            <div className="flex-shrink-0 flex items-start">
              {/* AVATAR */}
              <div className="relative rounded-full overflow-hidden flex">
                {/* <img
                  src={avatarImgs[2]}
                  alt=""
                  className="w-32 h-32 rounded-full object-cover z-0"
                /> */}
                <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center text-neutral-50 cursor-pointer">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 5H7.5C6.83696 5 6.20107 5.26339 5.73223 5.73223C5.26339 6.20107 5 6.83696 5 7.5V20M5 20V22.5C5 23.163 5.26339 23.7989 5.73223 24.2678C6.20107 24.7366 6.83696 25 7.5 25H22.5C23.163 25 23.7989 24.7366 24.2678 24.2678C24.7366 23.7989 25 23.163 25 22.5V17.5M5 20L10.7325 14.2675C11.2013 13.7988 11.8371 13.5355 12.5 13.5355C13.1629 13.5355 13.7987 13.7988 14.2675 14.2675L17.5 17.5M25 12.5V17.5M25 17.5L23.0175 15.5175C22.5487 15.0488 21.9129 14.7855 21.25 14.7855C20.5871 14.7855 19.9513 15.0488 19.4825 15.5175L17.5 17.5M17.5 17.5L20 20M22.5 5H27.5M25 2.5V7.5M17.5 10H17.5125"
                      stroke="currentColor"
                      strokeWidth={1.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <span className="mt-1 text-xs">Change Image</span>
                </div>
                <input
                  type="file"
                  className="absolute inset-0 opacity-0 cursor-pointer"
                />
              </div>
            </div>
            <div className="flex-grow mt-10 md:mt-0 md:pl-16 max-w-3xl space-y-6">
              <div>
                <Label>First Name</Label>
                <Input className="mt-1.5" defaultValue={userData?.firstName}/>
              </div>
 <div>
                <Label>Last Name</Label>
                <Input className="mt-1.5" defaultValue={userData?.lastName}/>
              </div>
              {/* ---- */}

              {/* ---- */}
              <div>
                <Label>Email</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                    <i className="text-2xl las la-envelope"></i>
                  </span>
                  <Input
                    className="!rounded-l-none"
                    placeholder={userData?.email}
                  />
                </div>
              </div>

              
              {/* ---- */}
              {/* <div>
                <Label>Addess</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                    <i className="text-2xl las la-map-signs"></i>
                  </span>
                  <Input
                    className="!rounded-l-none"
                    defaultValue="New york, USA"
                  />
                </div>
              </div> */}

            

              {/* ---- */}
              <div>
                <Label>Phone number</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                    <i className="text-2xl las la-phone-volume"></i>
                  </span>
                  <Input
                    className="!rounded-l-none"
                    defaultValue={userData?.phone||userData?.phoneNumber}
                  />
                </div>
              </div>
              
              {/* <div className="pt-2">
                <ButtonPrimary>Update account</ButtonPrimary>
              </div> */}
            </div>
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default AccountPage;
